import { createContext } from "react";
import type { BuilderUIStore } from "@circle-react-shared/BuilderUI/Store";

export const BuilderUIContext = createContext<BuilderUIStore | null>(null);

BuilderUIContext.displayName = "BuilderUIContext";
